var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"border-bottom"}),_c('div',{staticClass:"socials"},_vm._l((_vm.socialMedias),function(social){return _c('social-media-icon',{key:social.name,attrs:{"social":social}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }